export default __webpack_public_path__ + "static/media/759875643d36a660d33c4a605e0f51ee.png";